import { Component, OnInit, ViewChild, OnDestroy, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import {
    AppState,
    selectOperacionState,
    selectDetalleFacturaState,
} from 'app/store/app.states';
import { AsignarOperacion } from 'app/store/actions/operacion.actions';
import { BaseService } from 'app/services/base.service';
import { CoalService } from 'app/services/coal.service';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
import { RelacionadosDialogComponent } from 'app/utilerias/relacionados-dialog/relacionados-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import {
    FormBuilder,
    FormControl,
    FormControlName,
    FormGroup,
    Validators,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTable } from '@angular/material/table';
import {
    MostrarExcepcion,
    MostrarSpinner,
    OcultarSpinner,
} from 'app/store/actions/utils.action';
import { ConfirmDialogOkComponent } from 'app/utilerias/confirm-dialog-ok/confirm-dialog-ok.component';
import { ConfirmDialogOpcionComponent } from 'app/utilerias/confirm-dialog-opcion/confirm-dialog-opcion.component';
import { filter, switchMap, tap } from 'rxjs/operators';
import { filters } from '../../../../mock-api/apps/mailbox/data';
import { messages } from '../../../../mock-api/apps/chat/data';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
interface Food {
    value: string;
    viewValue: string;
}
const datosTabla1: any[] = [];
@Component({
    selector: 'app-impuestosComplemento',
    templateUrl: './impuestosComplemento.component.html',
    styleUrls: ['./impuestosComplemento.component.scss'],   
})
export class ImpuestosComplementoComponent implements OnInit, OnDestroy {
    @Input() lsNombre: string;
    @Input() countImpuestos: number;
    @Input() idDocRelacionados: string;
    @Input() updateDataImpuestos: any;
    @Input() banderaActualizarFactura: boolean;

    getStateOperacion: Observable<any>;
    subscribeOperacion: any;
    idOperacion: number;
    Operacion: any;
    getStateDetalleFactura: Observable<any>;
    impuestoComplementoForm: FormGroup;
    idImpuestos: string;
    impuestos = [];
    tasasDisponibles: any;
    tasasDinamica: any;
    tasaDin: any;

    constructor(
        private readonly store: Store<AppState>,
        private fb: FormBuilder,
        private baseService: BaseService,
        private coalService: CoalService,
        private router: Router,
        public dialog: MatDialog
    ) {
        this.impuestoComplementoForm = this.fb.group({
            impuestoComplemento: [''],
            baseComplemento: [''],
            tasaComplemento: [''],
            totalComplemento: [''],
        });
    }
    ngOnDestroy() {
        this.baseService.postDetalleFactura(null);
    }

    ngOnInit() {
        const getImpuestos$ = this.getImpuestos().pipe(
            tap(() => console.log('getImpuestos completado'))
        );

        const loadTasas$ = getImpuestos$.pipe(
            switchMap(() => this.loadTasas()),
            tap(() => console.log('loadTasas completado'))
        );
        var updImpuesto = this.updateDataImpuestos.attributes
        forkJoin([getImpuestos$, loadTasas$]).subscribe(() => {
            if (this.banderaActualizarFactura) {
                this.impuestoComplementoForm.controls.impuestoComplemento.setValue(
                    updImpuesto.cat_impuesto.data ? updImpuesto.cat_impuesto.data.id:null
                );
                
                this.impuestoComplementoForm.controls.baseComplemento.setValue(
                    updImpuesto.base
                );
                const tasas = this.tasasDisponibles.find(
                    (item) => item.impuesto === updImpuesto?.cat_impuesto?.data?.attributes?.impuesto
                ).tasas
                const tasaDi = tasas.find(
                    (item) => item.attributes.valor === updImpuesto?.tasa
                )
                this.actualizarTasaComplemento(updImpuesto.cat_impuesto.data.id)
                this.impuestoComplementoForm.controls.tasaComplemento.setValue(
                    tasaDi
                );
              
                this.impuestoComplementoForm.controls.totalComplemento.setValue(
                    updImpuesto.total
                );
            }
        });
        this.idImpuestos = 'impuesto' + this.countImpuestos;
        this.getStateOperacion = this.store.select(selectOperacionState);
        this.getStateDetalleFactura = this.store.select(
            selectDetalleFacturaState
        );

        this.impuestoComplementoForm = this.fb.group({
            impuestoComplemento: new FormControl(null),
            baseComplemento: new FormControl(0),
            tasaComplemento: new FormControl(null),
            totalComplemento: new FormControl(0),
        });

        this.impuestoComplementoForm.valueChanges.subscribe((res) => {
            let keyDocsRelacionados: number;
            let keyImpuestos: number;
            let lsJson = JSON.parse(localStorage.getItem(this.lsNombre));
            lsJson['pago'].documentosRelacionados.forEach((value, key) => {
                if (value[0].id === this.idDocRelacionados) {
                    keyDocsRelacionados = key;
                }
            });
            lsJson['pago'].documentosRelacionados[
                keyDocsRelacionados
            ][2].impuestos.forEach((value, key) => {
                if (value[0].id === this.idImpuestos) {
                    keyImpuestos = key;
                }
            });
            lsJson['pago'].documentosRelacionados[
                keyDocsRelacionados
            ][2].impuestos[keyImpuestos][1].data = res;
            localStorage.removeItem(this.lsNombre);
            localStorage.setItem(this.lsNombre, JSON.stringify(lsJson));
        });
    }

    calculateTotalComplemento(): void {
        const base = this.impuestoComplementoForm.get('baseComplemento').value;
        const tasa = this.impuestoComplementoForm.get('tasaComplemento').value?.attributes.valor

        if (base && tasa && !isNaN(base) && !isNaN(tasa)) {
            const totalComplemento = parseFloat(base) * parseFloat(tasa);
            this.impuestoComplementoForm.patchValue({
                totalComplemento: totalComplemento,
            });
        } else {
            this.impuestoComplementoForm.patchValue({ totalComplemento: '0' });
        }
    }

    getImpuestos(): Observable<any> {
        this.store.dispatch(MostrarSpinner());
        return this.coalService.getService('cat-impuestos').pipe(
            tap((res: any) => {
                this.impuestos = res.data;
                this.store.dispatch(OcultarSpinner());
            })
        );
    }
 
    loadTasas(): Observable<any> {
        const tasaObservables = this.impuestos
            .filter((impuesto) => impuesto.attributes.entidad !== null)
            .map((impuesto) =>
                this.coalService.getService(`${impuesto.attributes.entidad}`)
            );

        return forkJoin(tasaObservables).pipe(
            tap((tasasResults: any[]) => {
                const tasasDisponibles = [];
                this.impuestos.forEach((impuesto, index) => {
                    const impuestoNombre = impuesto.attributes.impuesto;
                    if (impuesto.attributes.entidad !== null) {
                        tasasDisponibles.push({
                            impuesto: impuestoNombre,
                            tasas: tasasResults[index].data,
                            disableTasa: false,
                        });
                        index++;
                    } else {
                        tasasDisponibles.push({
                            impuesto: impuestoNombre,
                            tasas: [],
                            disableTasa: true,
                        });
                    }
                });
    
                this.tasasDisponibles = tasasDisponibles;
                this.store.dispatch(OcultarSpinner());
            })
        );
    }

    actualizarTasaComplemento(imp: any) {
        let impuesto =  this.impuestos.find(
            (item) => item.id === imp
        );//.attributes.impuesto;
        
        const tasaComplementoControl =
            this.impuestoComplementoForm.get('tasaComplemento');

        this.impuestoComplementoForm.controls.tasaComplemento.enable();
        tasaComplementoControl.enable();
       
        const impuestoData = this.tasasDisponibles.find(
            (item) => item.impuesto === impuesto.attributes.impuesto
        );
        if (!this.banderaActualizarFactura) {
            this.impuestoComplementoForm.controls.baseComplemento.setValue(0);
            this.impuestoComplementoForm.controls.totalComplemento.setValue(0);
        }

        if (impuestoData) {  
            this.tasasDinamica = impuestoData.tasas;
        } else {
            tasaComplementoControl.setValue('');
            this.tasasDinamica = [];
        }
    }
}
